import { render } from "./permanent-categories.vue?vue&type=template&id=cebb4be7"
import script from "./permanent-categories.vue?vue&type=script&lang=js"
export * from "./permanent-categories.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__